
$(function () { /* query ready function */

    /* /Account/Register - enable radio button click helper */
    $(".radio-span").on("mousedown", function (el) {
        $(this).find("input").click();
    });

});